import React from 'react';

const IconMoreVert = ({ width, height, color }) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d={
          'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 ' +
          '.9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 ' +
          '2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 ' +
          '0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
        }
      />
    </svg>
  );
};

export default IconMoreVert;



// WEBPACK FOOTER //
// ./src/IconMoreVert.js